import { render, staticRenderFns } from "./translationDetail.vue?vue&type=template&id=29fca159"
import script from "./translationDetail.vue?vue&type=script&lang=js"
export * from "./translationDetail.vue?vue&type=script&lang=js"
import style0 from "./translationDetail.vue?vue&type=style&index=0&id=29fca159&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports